<div class="content">
  <p class="title">
    {{titleApp}}
  </p>
</div>
